import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    width: "27",
    height: "27",
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<circle cx="13.7079" cy="13.4423" r="12.3446" fill="#193446" stroke="#fff"/> <path d="M16.7333 18.7363H9.9589v-1.2168l2.5772-2.5908c.761-.7793 1.2646-1.3307 1.5107-1.6543.2507-.3281.433-.6357.5469-.9228.1139-.2871.1709-.5948.1709-.9229 0-.4512-.1367-.8066-.4102-1.0664-.2688-.2598-.6425-.3896-1.1211-.3896-.3828 0-.7542.0706-1.1142.2119-.3555.1412-.7679.3965-1.2373.7656l-.8682-1.0596c.556-.4694 1.096-.802 1.6201-.998.5241-.196 1.0824-.294 1.6748-.294.9297 0 1.6748.2439 2.2354.7315.5605.483.8408 1.1347.8408 1.9551 0 .4511-.082.8795-.2461 1.2851-.1595.4056-.4079.8249-.7451 1.2578-.3327.4284-.8887 1.0095-1.668 1.7432l-1.7363 1.6816v.0684h4.7441v1.415Z" fill="#fff"/>' }
  })
);